export const getEmailBodyStrategy = (displayType) => {
    const strategies = {
        'guide-sections': constructBodyBySections,
        'default': echo,
        'diet': echo
    };

    if (!strategies[displayType]) {
        return echo;
    }

    return strategies[displayType];
};

const echo = (prompts, filteredResults) => {
    return filteredResults;
}

const constructBodyBySections = (prompts, filteredResults) => {
    let { parentSectionMapping, requiredSections } = parseSectionsData(prompts);

    let sections = requiredSections;

    filteredResults.sort((a, b) => a.id < b.id ? -1 : 1);

    for (let subsection of filteredResults) {
        const filter = subsection.filters[0];
        const parentSectionId = parentSectionMapping[filter];

        if (sections[parentSectionId]) {
            sections[parentSectionId].subsections.push(subsection);

        } else {
            let section = prompts[parentSectionId].resultSectionConfig;
            section.subsections = [subsection];

            sections[parentSectionId] = section;
        }
    }

    return Object.values(sections);
}

const parseSectionsData = (prompts) => {
    let parentSectionMapping = {};
    let requiredSections = {};

    for (let promptId in prompts) {
        const prompt = prompts[promptId];

        for (let filterObj of prompt.filters) {
            parentSectionMapping[filterObj.tag] = +promptId;
        }

        if (prompt.resultSectionConfig && prompt.resultSectionConfig.required) {
            let section = prompt.resultSectionConfig;
            section.subsections = [];

            requiredSections[+promptId] = section;
        }
    }

    return { parentSectionMapping, requiredSections };
}